<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-left-panel :span="4">
        <el-button icon="el-icon-plus" type="primary" @click="handleEdit(null)">
          新增分账方
        </el-button>
      </vab-query-form-left-panel>
      <vab-query-form-right-panel :span="20">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              class="pr-10"
              clearable
              placeholder="关键词(搜索标题，详情等)"
            />
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="标题"
        prop="title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="门店"
        prop="branch.title"
        show-overflow-tooltip
      />
      <el-table-column
        align="left"
        label="支付宝账户"
        prop="basic.alipay.account"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="类型" show-overflow-tooltip>
        <template #default="{ row }">
          {{
            row.basic.alipay.typehood
              ? row.basic.alipay.typehood == 1
                ? '个人'
                : '公司'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="名称"
        prop="basic.alipay.name"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="分账关系" show-overflow-tooltip>
        <template #default="{ row }">
          {{
            row.basic.alipay.typehood
              ? row.basic.alipay.typehood == 1
                ? '门店'
                : row.basic.alipay.typehood == 2
                ? '员工'
                : row.basic.alipay.typehood == 3
                ? '店主'
                : '合作伙伴'
              : ''
          }}
        </template>
      </el-table-column>
      <!-- 微信 -->
      <el-table-column
        align="left"
        label="微信账户"
        prop="basic.wepay.account"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="类型" show-overflow-tooltip>
        <template #default="{ row }">
          {{
            row.basic.wepay.typehood
              ? row.basic.wepay.typehood == 1
                ? '个人'
                : '公司'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="名称"
        prop="basic.wepay.name"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="分账关系" show-overflow-tooltip>
        <template #default="{ row }">
          {{
            row.basic.wepay.typehood
              ? row.basic.wepay.typehood == 1
                ? '门店'
                : row.basic.wepay.typehood == 2
                ? '员工'
                : row.basic.wepay.typehood == 3
                ? '店主'
                : '合作伙伴'
              : ''
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建日期"
        prop="created"
        show-overflow-tooltip
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="150px"
      >
        <template #default="{ row }">
          <el-button type="text" class="mr-10" @click="handleDelete(row)">
            删除
          </el-button>
          <el-button type="text" class="mr-10" @click="handleEdit(row)">
            修改
          </el-button>
        </template>
      </el-table-column>
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit ref="edit" @fetch-data="fetchData" />
  </div>
</template>

<script>
import moment from 'moment'
import { findReceiverList, removeReceiver } from '@/api/splitAccount'
import Edit from './edit.vue'
export default {
  name: 'SplitAccount',
  components: { Edit },
  data() {
    return {
      moment,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        keyword: '',
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/splitAccount/index') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleCommand(command) {
      switch (command.cmd) {
        case 'edit':
          this.handleEdit(command.item)
          break
        case 'delete':
          this.handleDelete(command.item)
          break
      }
    },
    handleEdit(row) {
      this.$refs['edit'].showEdit(row)
    },
    handleShow(row) {
      this.$refs['show'].show(row)
    },
    handleDelete(row) {
      this.$baseConfirm(
        `你确定要删除分账方：${row.title} 吗`,
        null,
        async () => {
          await removeReceiver({ receiverId: row.receiverId })
          this.$baseMessage(
            `删除分账方成功`,
            'success',
            false,
            'vab-hey-message-success'
          )
          this.queryData()
        }
      )
    },
    setSelectRows(val) {
      this.selectRows = val
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const { list, total } = await findReceiverList(this.queryForm)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.mr-10 {
  margin-right: 10px;
}
.pr-10 {
  padding-right: 10px;
}
.el-dropdown-link {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.avatar {
  height: 64px;
  width: 64px;
  border-radius: 8px;
}
.big-avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
